import { InjectionToken } from '@angular/core';

export const configClientId = new InjectionToken<string>('Client id - app');
export const configScope = new InjectionToken<string>('All scopes for app, separated with whitespaces');

/**
 * Tells auth whether the app runs on a mobile device; sent with device register/update
 * requests. Apps that configure deviceRegisterUrl/deviceUpdateUrl provide it - the
 * platform layer must not depend on the shared device detection itself. Deliberately
 * has no default: a configured device URL without this token logs a warning at startup.
 */
export const KROS_AUTH_IS_MOBILE = new InjectionToken<() => boolean>('KROS_AUTH_IS_MOBILE');
